import { useState } from "react";

import { useMutation, useQuery, useQueryClient } from "react-query";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";
import InvoiceIcon from "../../../Components/Common/svg/Invoice";
import CurioerInfo from "../../../Components/orders/show/curioerInfo";
import MultistoreChildren from "../../../Components/orders/show/multistoreChildren";
import OrderSummary from "../../../Components/orders/show/orderSummary";
import PackageCard from "../../../Components/orders/show/packageInfo";
import PaymentInfo from "../../../Components/orders/show/paymentInfo";
import StatusBadge from "../../../Components/orders/show/statusbadge";
import StoreInfo from "../../../Components/orders/show/storeInfo";
import TimeLineInfo from "../../../Components/orders/show/timelineInfo";
import UserInfo from "../../../Components/orders/show/userInfo";
import HeaderBar from "../../../Components/UI/headerbar";
import LoadingSpinner from "../../../Components/UI/spinner";
import { getInvoice, showOrders, updateOrders } from "../../../MyApi/orders";
import usePusher from "../../../utils/usepusher";
import Error from "../../error";
import AppointCourierModal from "../../../Components/orders/show/appointCourierModal";
import ReceiptsInfo from "../../../Components/orders/show/receiptsInfo";

const OrderShowPage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [showCourierModal, setShowCourierModal] = useState(false);
  const queryClient = useQueryClient();
  const isVendor = localStorage.getItem("is_vendor");
  const statusMap = {
    pending: "confirmed",
    confirmed: "processing",
    processing: "ready_for_delivery",
    ready_for_delivery: "on_the_way",
    on_the_way: "delivered",
  };

  const actionLabelMap = {
    pending: "تأكيد الطلب",
    confirmed: "بدء التجهيز",
    processing: "جاهز للاستلام",
    ready_for_delivery: "في طريق للتوصيل",
    on_the_way: "تأكيد التسليم",
  };
  usePusher({
    channelName: `private-order.${id}`,
    eventName: "order.status.changed",
    onEvent: (event) => {
      console.log("PUSHER EVENT RECEIVED", event);
      if (!event) return;

      //   changed_at

      // new_status

      // old_status

      // order_id

      queryClient.setQueryData(["showorders", id], (oldData) => {
        if (!oldData) return oldData;
        console.log("oldData", oldData);
        const order = oldData.data.order;

        if (order.status?.value === event.new_status) {
          return oldData;
        }
        const parent_id = oldData.data.order.id;

        const newHistoryItem = {
          id: `pusher-${Date.now()}`, // temp id
          status: {
            value: event.new_status,
            label: statusMap[event.new_status] || event.new_status,
          },
          note: `Status changed from ${event.old_status} to ${event.new_status}`,
          changed_at: event.changed_at,
          created_at: event.changed_at,
        };

        return {
          ...oldData,
          data: {
            ...oldData.data,
            order: {
              ...order,
              children: (order.children || []).map((child) => {
                if (child.id === event.order_id) {
                  return {
                    ...child,
                    status: {
                      label: statusMap[event.new_status] || child.status.label,
                      value: event.new_status,
                    },
                  };
                } else {
                  return child;
                }
              }),

              status:
                parent_id === event.order_id
                  ? {
                      ...order.status,
                      value: event.new_status,
                      label: statusMap[event.new_status] || order.status.label,
                    }
                  : order.status,

              // إضافة للتاريخ
              status_history:
                parent_id === event.order_id
                  ? [...order.status_history, newHistoryItem]
                  : order.status_history,
            },
          },
        };
      });
    },
  });

  const { data, isLoading, refetch, error, isError } = useQuery(
    ["showorders", id],
    () => showOrders(id),
  );
  const orderDataShow = data?.data?.order || {};
  const {
    order_number,
    status = {},
    user = {},
    store,
    items = [],
    pricing = {},
    status_history = [],
    payment_status = {},
    payment_method = {},
    courier = {},
    type = {},
    delivery = {},
    receipts = [],

    package: packageOrder = {},
  } = orderDataShow;

  const mutation = useMutation({
    mutationKey: ["updateOrder"],
    mutationFn: (postData) => updateOrders(postData, id),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      refetch();
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "حدث خطأ ما");
    },
  });

  const handleUpdateOrder = (newStatus) => {
    let updatedStatus;

    if (isVendor) {
      // vendor يقدر يوصل لحد processing فقط
      if (status.value === "pending") {
        updatedStatus = "confirmed";
      } else if (status.value === "confirmed") {
        updatedStatus = "processing"; // جاري الاستلام
      } else {
        toast.error("هذا التحديث غير متاح  لصلاحية التاجر");
        return; // يمنع أي تحديث بعد كده
      }
    } else {
      // flow الطبيعي
      updatedStatus = newStatus || statusMap[status.value] || "";
    }

    mutation.mutate({
      _method: "PUT",
      status: updatedStatus,
    });
  };

  const handlePostCourier = () => {
    setShowCourierModal(true);
  };

  if (error?.response?.status === 404) {
    return <Error />;
  }

  return (
    <>
      {isLoading && <LoadingSpinner />}
      <HeaderBar title={"إدراة الطلبات"} isBack={true} />
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center ">
          <div className="d-flex align-items-center gap-3">
            <div className="fw-bold">طلب رقم: {order_number}</div>
            <StatusBadge status={status?.value} />
          </div>

          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-white d-flex align-items-center gap-2"
              onClick={() => getInvoice(id, setLoading)}
              disabled={loading}
            >
              طباع فاتورة {loading ? <Spinner size={"sm"} /> : <InvoiceIcon />}
            </button>
            {/* <button className="btn btn-white d-flex align-items-center gap-2">
            استرداد <CardIcon />
          </button> */}
          </div>
        </div>
        <div className="row">
          <div className="card rounded-4 mt-3 shadow-sm ">
            <div className="card-body p-2">
              <div className="d-flex justify-content-between align-items-center ">
                <div>
                  <h5 className="mb-3">حالة الطلب</h5>
                  <StatusBadge status={status?.value} />
                  <span className="badge bg-primary ms-2"> {type?.value}</span>
                </div>

                <div className="d-flex gap-3">
                  {status?.value === "delivered" ||
                  status?.value === "cancelled" ||
                  status?.value === "pending" ? null : (
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => handlePostCourier()}
                      disabled={mutation.isLoading}
                    >
                      تعيين السائق
                    </button>
                  )}
                  {status?.value === "delivered" ||
                  status?.value === "cancelled" ? null : (
                    <button
                      className="btn btn-sm  btn-primary"
                      onClick={() => handleUpdateOrder()}
                      disabled={mutation.isLoading}
                    >
                      {" "}
                      {mutation.isLoading
                        ? "جاري التحديث..."
                        : actionLabelMap[status?.value]}
                    </button>
                  )}
                  {status?.value === "delivered" ||
                  status?.value === "cancelled" ? null : (
                    <button
                      className="btn btn-sm  btn-danger"
                      onClick={() => handleUpdateOrder("cancelled")}
                      disabled={mutation.isLoading}
                    >
                      إلغاء الطلب
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <UserInfo user={user} delivery={delivery} />
          {courier && <CurioerInfo courier={courier} />}
          {type?.value === "package" ? (
            <PackageCard packageOrder={packageOrder} />
          ) : orderDataShow.is_multistore ? (
            <MultistoreChildren
              children={orderDataShow.children}
              refetch={refetch}
              id={id}
            />
          ) : (
            <StoreInfo store={store} />
          )}
          <PaymentInfo
            payment_status={payment_status}
            payment_method={payment_method}
          />
        </div>
        <div className="row">
          <OrderSummary pricing={pricing} items={items} />
          <TimeLineInfo
            status_history={status_history}
            refetch={refetch}
            type={type?.value}
          />
          <ReceiptsInfo receipts={receipts} />
        </div>
      </div>

      <AppointCourierModal
        show={showCourierModal}
        onClose={() => setShowCourierModal(false)}
        orderId={id}
        refetch={refetch}
        // storeId={store?.id}
      />
    </>
  );
};

export default OrderShowPage;
